module.exports = __webpack_public_path__ + "img/14.74eee35.png";